export const FIELD_ID = 'id';
export const FIELD_LASTNAME = 'lastname';
export const FIELD_NAME = 'name';
export const FIELD_PATRONYMIC = 'patronymic';
export const FIELD_COMPANY = 'company';
export const FIELD_REGALIA = 'regalia';
export const FIELD_BIOGRAPHY = 'biography';
export const FIELD_ACTIVITY = 'activity';
export const FIELD_TAGS = 'tags';
export const FIELD_ROLES = 'roles';
export const FIELD_VK = 'vk';
export const FIELD_TELEGRAM = 'telegram';
export const FIELD_DZEN = 'dzen';

export const TITLE_RU = 'titleRu';
export const TITLE_EN = 'titleEn';
export const GROUP_TITLE_RU = 'groupTitleRu';
export const GROUP_TITLE_EN = 'groupTitleEn';

export const PARTICIPANT_LASTNAME_RU = 'lastnameRu';
export const PARTICIPANT_LASTNAME_EN = 'lastnameEn';
export const PARTICIPANT_NAME_RU = 'nameRu';
export const PARTICIPANT_NAME_EN = 'nameEn';
export const PARTICIPANT_PATRONYMIC_RU = 'patronymicRu';
export const PARTICIPANT_PATRONYMIC_EN = 'patronymicEn';
export const PARTICIPANT_COMPANY_RU = 'companyRu';
export const PARTICIPANT_COMPANY_EN = 'companyEn';
export const PARTICIPANT_REGALIA_RU = 'regaliaRu';
export const PARTICIPANT_REGALIA_EN = 'regaliaEn';
export const PARTICIPANT_BIOGRAPHY_RU = 'biographyRu';
export const PARTICIPANT_BIOGRAPHY_EN = 'biographyEn';
export const PARTICIPANT_VK = 'linkVk';
export const PARTICIPANT_TELEGRAM = 'linkTelegram';
export const PARTICIPANT_DZEN = 'linkDzen';
export const PARTICIPANT_PHOTO = 'photo';
export const PARTICIPANT_PROFILE_URL = 'profileUrl';
export const PARTICIPANT_PROFILE_PATH = 'profilePath';
export const PARTICIPANT_ROLES = 'roles';
export const PARTICIPANT_TAGS = 'tags';
export const ALLOW_QUESTIONS = 'allowQuestions';
